export var DEFAULT_REVEAL_DURATION = 1000;
export var DEFAULT_REVEAL_DELAY = 0;
export var DEFAULT_CASCADE_FACTOR = 0.5;
export var DEFAULT_CASCADE_FRACTION = 0.05;
export var DEFAULT_REVEAL_PROPS = {
  duration: DEFAULT_REVEAL_DURATION,
  delay: DEFAULT_REVEAL_DELAY,
  disableAnimation: false,
  disableAnimationOnMobile: false,
  cascade: false,
  cascadeFactor: DEFAULT_CASCADE_FACTOR,
  triggerOnce: false,
  // eslint-disable-next-line no-unused-vars
  onVisibilityChange: function onVisibilityChange(inView, intersectionObserverEntry) {
    return null;
  },
  fraction: DEFAULT_CASCADE_FRACTION,
  noContainer: false
};